<template>
  <v-container v-if="formulacion !== null" grid-list-xl>
    <br />
    <v-toolbar flat color="primary">
      <v-toolbar-title
        class="text-white"
      >{{formulacion.idnacionalNavigation.descripcion}} - {{formulacion.idperiodoNavigation.nombre}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon x-large v-on="on" @click="saveformulacion" :disabled="!puedesalvar">
              <v-icon color="white">save</v-icon>
            </v-btn>
          </template>
          <span>Guardar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              x-large
              color="white"
              @click="finalizarformulacion"
              v-on="on"
              :disabled="!puedesalvar"
            >
              <v-icon>send</v-icon>
            </v-btn>
          </template>
          <span>Finalizar</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>
    
    <v-tabs show-arrows next-icon="fa-caret-right" prev-icon="fa-caret-left"  background-color="blue-grey lighten-4" horizontal v-if="nacional!==null">
      <v-tabs-slider></v-tabs-slider>
      <v-tab>
        <v-icon left>folder</v-icon>Datos básicos
      </v-tab>
      <v-tab v-show="showcontrol('editaestrategia')">
        <v-icon left>work</v-icon>Estrategias
      </v-tab>
      <v-tab v-show="showcontrol('editafinanciamiento')">
        <v-icon left>local_atm</v-icon>Presupuesto
      </v-tab>
      <v-tab>
        <v-icon left>history</v-icon>Histórico
      </v-tab>
      <v-tab-item>
        <v-card flat :loading="salvando">
          <v-card-title></v-card-title>
          <v-card-text>
            <v-flex sm12 xs12>
              <v-textarea v-model="nacional.nombre" label="Nombre:" :counter="200" :readonly="true"></v-textarea>
            </v-flex>
            <v-flex sm12 xs12>
              <v-textarea
                v-model="nacional.objetivo"
                label="Objetivo:"
                :counter="1000"
                :readonly="true"
              ></v-textarea>
            </v-flex>
            <v-flex sm12 xs12>
              <!-- <v-textarea
                v-model="nacional.especificos"
                label="Objetivos específicos:"
                :readonly="true"
                :counter="2000"
              ></v-textarea> -->
              <label for="objetivosespecificos" class="form-label">Objetivos específicos:</label>
              <quill-editor
                
                v-model="nacional.especificos"
                
                :disabled="true"
                :options="editorOptionsObjetivosEspecificos"
                @ready="onEditorReady($event)"
                
              />
              <div id="counter3" class="counter"></div>
            </v-flex>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="nacional.inicio"
                  label="Fecha inicio:"
                  :readonly="true"
                  type="number"
                  min="2017"
                  max="2050"
                ></v-text-field>
              </v-col>

              <v-col>
                <v-text-field
                  v-model="nacional.fin"
                  label="Fecha fin:"
                  type="number"
                  :readonly="true"
                  min="2017"
                  max="2050"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-flex xs12 sm12>
              <img
                width="240px"
                class="mx-auto d-block"
                v-bind:src="formulacion.idnacionalNavigation.imagen"
              />
            </v-flex>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card :loading="salvando">
          <v-card-title></v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headerestrategia"
              :items="estrategias"
              class="elevation-1"
              :no-data-text="gnodata"
              :items-per-page="10"
            >
              <template v-slot:item.actividades="{ item }">
                <v-badge
                  :color="coloractividad(item.actividades)"
                  :content="item.actividades"
                >Actividades</v-badge>
              </template>
              <template v-slot:item.ponderado="{ item }">
                <v-badge :color="colorponderado(item.ponderado)" :content="item.ponderado">Ponderado</v-badge>
              </template>
              <template v-slot:item.action="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      small
                      class="mr-2"
                      @click="grideditestrategia(item)"
                      v-scroll-to="'#containerc'"
                    >mdi-eye</v-icon>
                  </template>
                  <span v-if="puedeeditarestrategia">Ver</span>
                  <span v-else>Ver</span>
                </v-tooltip>
              </template>
            </v-data-table>
            
            <v-card v-if="frameestrategia" id="containerc" ref="containerc">
              <v-card-title>Edición de estrategia - {{estrategia.nombre}}</v-card-title>
              <v-card-text>
                <v-toolbar>
                  <v-toolbar-title>Lista de actividades</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-tooltip top v-if="puedeeditarestrategia && puedesalvar">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        x-large
                        v-on="on"
                        @click="newactividad"
                      >
                        <v-icon color="primary">add</v-icon>
                      </v-btn>
                    </template>
                    <span>Agregar</span>
                  </v-tooltip>
                </v-toolbar>
                <v-data-table
                  :headers="headeractividad"
                  :items="actividades"
                  class="elevation-1"
                  :no-data-text="gnodata"
                  :items-per-page="10"
                >
                  <template v-slot:item.fechacumplimiento="{ item }">{{formato(item)}}</template>
                  
                  <template v-slot:item.nombre="{ item }">
                    <v-badge v-if="item.idactividad===0" color="orange" content="nuevo" >
                      <p v-html="item.nombre"></p>
                  </v-badge>
                    <p v-else v-html="item.nombre">
                    </p>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <td v-if="puedeeditarestrategia && puedesalvar">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small class="mr-2" @click="grideditactividad(item)">edit</v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            small
                            class="mr-2"
                            @click="deleteactividad(item)"
                          >mdi-delete</v-icon>
                        </template>
                        <span>Eliminar</span>
                      </v-tooltip>
                    </td>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card :loading="salvando">
          <v-card-title></v-card-title>
          <v-card-text>
            <v-toolbar v-if="puedeeditarfinanciamiento && puedesalvar">
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    x-large
                    v-on="on"
                    @click="newpresupuesto"
                  >
                    <v-icon color="primary">add</v-icon>
                  </v-btn>
                </template>
                <span>Agregar</span>
              </v-tooltip>
            </v-toolbar>
            <v-data-table
              :headers="headerpresupuesto"
              :items="formulacion.financiamiento"
              class="elevation-1"
              :no-data-text="gnodata"
              :items-per-page="10"
            >
              <template v-slot:item.apropiacion="{ item }">
                <v-badge v-if="item.idfinanciamiento===0" color="orange" content="nuevo">
                  <p>{{moneda(item.apropiacion)}}</p>
                </v-badge>
                <p v-else>{{moneda(item.apropiacion)}}</p>
              </template>
              <template v-slot:item.action="{ item }">
                <div v-if="puedeeditarfinanciamiento && puedesalvar">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" small class="mr-2" @click="grideditpresupuesto(item)">edit</v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        small
                        class="mr-2"
                        @click="deletepresupuesto(item)"
                      >mdi-delete</v-icon>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <historico :idtabla="15" :idelemento="formulacion.idnacionalformulacion"></historico>
      </v-tab-item>
    </v-tabs>
    <v-flex xs12 sm12 v-show="showaprobacion('aprobado')">
      <v-card tile :loading="salvando">
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>Revisión de la formulación</v-toolbar-title>
          <div class="flex-grow-1"></div>
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 sm12>
            <!-- <v-textarea
              v-validate="'max:4000'"
              data-vv-name="revisioncomentario"
              :error-messages="errors.collect('revisioncomentario')"
              :counter="4000"
              v-model="formulacion.comentarioflujo"
              label="Comentario:"
              :disabled="readcontrol('aprobado')"
            ></v-textarea> -->
            <label for="revisioncomentario" class="form-label">Comentario:</label>
            <quill-editor
              ref="revisioncomentario"
              id="revisioncomentario"
              data-vv-name="revisioncomentario"
              :error-messages="errors.collect('revisioncomentario')"
              v-model="formulacion.comentarioflujo"
              :disabled="readcontrol('aprobado') == true"
              :options="editorOptionsRevisionComentario"
              @ready="onEditorReady($event)"
              
            />
            <div id="counter" class="counter"></div>
          </v-flex>
          <v-flex row>
            <v-flex xs6 sm6></v-flex>
            <v-flex xs6 sm6>
              <v-select
                :items="dropdown_comment"
                v-model="formulacion.aprobado"
                item-text="text"
                item-value="value"
                label="Seleccione opción"
              ></v-select>
            </v-flex>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-speed-dial
      v-show="puedesalvar"
      fixed
      :bottom="true"
      :right="true"
      direction="left"
      :open-on-hover="true"
      transition="scale-transition"
    >
      <template v-slot:activator>
        <v-btn fab color="blue-grey lighten-3">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <v-btn id="btnp1" fab dark small color="green" @click="finalizarformulacion">
        <v-icon>send</v-icon>
      </v-btn>
      <v-btn fab dark small color="green" @click="saveformulacion">
        <v-icon>save</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Confirmar eliminación</v-card-title>
        <v-card-text>
          <br />
          Cuando se guarde la formulación del plan nacional, se procederá a realizar la eliminación definitiva de la actividad: {{actividad.nombre}}, ¿confirma la ejecución de esta operación?.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="deleteexistente">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogpresupuesto" v-if="dialogpresupuesto" width="500" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Confirmar eliminación</v-card-title>
        <v-card-text>
          <br />
          Cuando se guarde la formulación del plan nacional, se procederá a realizar la eliminación definitiva del registro de presupuesto: {{pilar.nombrecompleto}} - {{fuente.nombre}}, ¿confirma la ejecución de esta operación?.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogpresupuesto = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="deletepresupuestoexistente">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editpresupuesto" width="800" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Edición de presupuesto</v-card-title>
        <v-card-text>
          <br />
          <form data-vv-scope="form-presupuesto">
            <v-row>
              <v-col>
                <v-select
                  label="Punto: *"
                  item-text="nombre"
                  item-value="idpunto"
                  value="idpunto"
                  :no-data-text="gnodata"
                  :items="gpuntos"
                  return-object
                  v-model="punto"
                  v-validate="'required'"
                  data-vv-name="punto"
                  :error-messages="errors.collect('punto', 'form-presupuesto')"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  label="Pilar: *"
                  :no-data-text="gnodata"
                  item-text="nombrecompleto"
                  :items="pilares"
                  return-object
                  v-model="pilar"
                  v-validate="'required|financiamientounico'"
                  data-vv-name="pilar"
                  :error-messages="errors.collect('pilar', 'form-presupuesto')"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  label="Fuente de financiamiento: *"
                  :no-data-text="gnodata"
                  item-text="nombre"
                  :items="gfuentes"
                  return-object
                  v-model="fuente"
                  v-validate="'required|financiamientounico'"
                  data-vv-name="fuente"
                  :error-messages="errors.collect('fuente', 'form-presupuesto')"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-validate="'required|between:1,1000000000000000'"
                  data-vv-name="apropiacion"
                  :error-messages="errors.collect('apropiacion', 'form-presupuesto')"
                  v-model="presupuesto.apropiacion"
                  label="Apropiación: *"
                  type="number"
                  min="1"
                  max="1000000000000000"
                ></v-text-field>
              </v-col>
            </v-row>
          </form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="editpresupuesto = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="preventguardarpresupuesto">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editactividad" width="500" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Edición de actividad</v-card-title>
        <v-card-text>
          <br />
          <form data-vv-scope="form-actividad">
            <v-row>
              <v-col>
                <!-- <v-textarea
                  v-model="actividad.nombre"
                  label="Actividad: *"
                  v-validate="'required|max:1000'"
                  :counter="1000"
                  data-vv-name="actividad"
                  :error-messages="errors.collect('actividad')"
                ></v-textarea> -->
                <label for="actividad" class="form-label">Actividad: *</label>
                <quill-editor
                  ref="actividad"
                  id="actividad"
                  data-vv-name="actividad"
                  :error-messages="errors.collect('actividad')"
                  v-model="actividad.nombre"
                  :options="editorOptionsActividad"
                  @ready="onEditorReady($event)"
                  
                />

                <div id="counter2" class="counter2"></div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-validate="'required|between:1,100|decimal:2'"
                  data-vv-name="ponderado"
                  :error-messages="errors.collect('ponderado')"
                  v-model="actividad.ponderacion"
                  label="Ponderación: *"
                  type="number"
                  min="1"
                  max="100"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fechaformato"
                      label="Fecha cumplimiento: *"
                      prepend-icon="event"
                      readonly
                      v-validate="validacionfecha"
                      data-vv-name="fechacumplimiento"
                      :error-messages="errors.collect('fechacumplimiento')"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fecha"
                    no-title
                    @input="menu2 = false"
                    scrollable
                    locale="es"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="editactividad = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="preventguardaractividad">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snack" :timeout="timeoutsnak" vertical top :color="MesaggeInfo.color">
      {{this.MesaggeInfo.codigoRespuesta}}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="functionalert">{{buttontext}}</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import historico from "../../components/content/historico";
import { ErrorBag } from 'vee-validate';
import Counter from "../../components/global/counter.js";
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill';
var Delta = Quill.import('delta');
Quill.register('modules/counter', Counter);

export default {
  name: "formulacion",
  data() {
    return {
      existefinanciamiento: false,
      formulacion: null,
      nacional: null,
      estrategias: [],
      presupuestos: [],
      estrategia: null,
      frameestrategia: false,
      menu2: false,
      actividad: { nombre: "" },
      presupuesto: {},
      editactividad: false,
      nuevaactividad: false,
      indexestrategia: 0,
      indexactividad: 0,
      editpresupuesto: false,
      nuevopresupuesto: false,
      dialogpresupuesto: false,
      puedeeditarestrategia: false,
      puedeeditarfinanciamiento: false,
      punto: {},
      pilares: [],
      pilar: {},
      fuente: {},
      estadocampos: [],
      salvando: false,
      permisosalvar: false,
      dialog: false,
      fecha: new Date().toISOString().substr(0, 10),
      fechaformato: null,
      buttontext: "Cerrar",
      timeoutsnak: 5000,
      dropdown_comment: [
        { text: "Aprobar", value: true },
        { text: "Rechazar", value: false },
      ],
      headerestrategia: [
        { text: "Estrategia", value: "nombre", align: "rigth" },
        { text: "", value: "actividades", align: "center", width: 200 },
        { text: "", value: "ponderado", align: "center" },
        {
          text: "Acción",
          value: "action",
          sortable: false,
          width: 100,
          align: "center",
        },
      ],
      headeractividad: [
        { text: "Actividad", value: "nombre", align: "rigth", width: "50%" },
        {
          text: "Ponderación",
          value: "ponderacion",
          align: "center",
          width: "25%",
        },
        {
          text: "Fecha de cumplimiento",
          value: "fechacumplimiento",
          align: "center",
          width: "25%",
        },
        { text: "Acción", value: "action", sortable: false, width: 150 },
      ],
      headerpresupuesto: [
        { text: "Punto", value: "nombrepunto", align: "rigth", width: "25%" },
        { text: "Pilar", value: "nombrepilar", align: "rigth", width: "25%" },
        {
          text: "Fuente de financiación",
          value: "nombrefuente",
          align: "left",
          width: "25%",
        },
        {
          text: "Apropiación",
          value: "apropiacion",
          align: "rigth",
          width: "25%",
        },
        { text: "Acción", value: "action", sortable: false, width: 150 },
      ],
      validacionfecha: "",
      //errores
      snack: false,
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      //Validacion de campos
      dictionary: {
        custom: {
          actividad: {
            required: () => "El nombre de la actividad es obligatoria",
            max: "Está superando el límite de caracteres",
          },
          ponderado: {
            required: () => "La ponderación de la actividad es obligatoria",
            between: () =>
              "El valor de ponderación debe estar en un rango entre 1 y 100",
            numeric: () =>
              "La ponderación solamente tiene en cuenta número enteros",
              decimal: "solo numeros con el siguiente formato (.##) ",
          },
          fechacumplimiento: {
            required: () =>
              "La fecha de cumplimiento de la actividad es obligatoria",
            date_between: () =>
              "La Fecha de cumplimiento debe estar dentro del año del plan de acción",
          },
          revisioncomentario: {
            max: "Está superando el límite de caracteres",
          },
          punto: {
            required: () => "El punto del presupuesto es obligatorio",
          },
          pilar: {
            required: () => "El pilar del presupuesto es obligatorio",
          },
          fuente: {
            required: () => "La fuente de financiamiento es obligatoria",
          },
          apropiacion: {
            required: () =>
              "El valor de la apropiación es obligatorio y no se deben usar ni puntos ni comas",
            between: () =>
              "El valor de apropiación debe estar en un rango entre 1 y 1.000.000.000.000.000",
          },
        },
      },
      quill: null,
      editorOptionsRevisionComentario: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ indent: "-1" }, { indent: "+1" }],
            ],
          },
          counter: {
            container: '#counter',
            controlContainer: '#revisioncomentario',
            unit: 'letra',
            max: 8000
          },
          clipboard: {
            matchers: [
              [ Node.ELEMENT_NODE, function(node, delta) {
                return delta.compose(new Delta().retain(delta.length(), 
                { 
                  align: "justify",
                  link: false,
                  color: false,
                  size:"12px",
                  header: false
                }
                ));
                }
              ] 
            ]
          }
        },
        placeholder: "",
      },
      editorOptionsObjetivosEspecificos: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ indent: "-1" }, { indent: "+1" }],
            ],
          },
          counter: {
            container: '#counter3',
            controlContainer: '#objetivosespecificos',
            unit: 'letra',
            max: 8000
          },
          clipboard: {
            matchers: [
              [ Node.ELEMENT_NODE, function(node, delta) {
                return delta.compose(new Delta().retain(delta.length(), 
                { 
                  align: "justify",
                  link: false,
                  color: false,
                  size:"12px",
                  header: false
                }
                ));
                }
              ] 
            ]
          }
        },
        placeholder: "",
      },
      editorOptionsActividad: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ indent: "-1" }, { indent: "+1" }],
            ],
          },
          counter: {
            container: '#counter2',
            controlContainer: '#actividad',
            unit: 'letra',
            max: 2000
          },
          clipboard: {
            matchers: [
              [ Node.ELEMENT_NODE, function(node, delta) {
                return delta.compose(new Delta().retain(delta.length(), 
                { 
                  align: "justify",
                  link: false,
                  color: false,
                  size:"12px",
                  header: false
                }
                ));
                }
              ] 
            ]
          }
        },
        placeholder: "",
      },
    };
  },

  created() {
    let user = this.getusuario();
    let auten = user.token.replace("Bearer ", "");
    this.$aes.setKey(auten);
    let temporal = this.$route.params.idnacionalformulacion.replace(
      /AbcYq/g,
      "/"
    );
    temporal = temporal.replace(/qYcbA/g, "+");
    temporal = this.$aes.decrypt(temporal);
    temporal = temporal.substring(4);
    temporal = temporal.substring(0, temporal.length - 4);
    temporal = this.$aes.decrypt(temporal);
    let id = temporal;
    this.get_nacionalformulacion({
      params: {
        idnacionalformulacion: id,
      },
    });
    this.get_puntos();
    this.get_pilares();
    this.get_fuentes();

    const FinanciamientoUnico = (value, args) =>
      new Promise((resolve) => {
        setTimeout(() => {
          this.get_existefinanciamiento({
            params: {
              idpilar: this.pilar.idpilar !== null ? this.pilar.idpilar: 0,
              idfuente: this.fuente !== null ? this.fuente.idfuente: 0,
              idnacionalformulacion: this.formulacion.idnacionalformulacion,
            },
          }).then(
            value => {
              if (!this.existefinanciamiento && !this.existepresupuestosinguardar()) {
                return resolve({
                  valid: true,
                });
            
              }
            return resolve({
              valid: false,
              data: {
                message: `El financiamiento con la combinación que intenta ingresar ya existe`,
              },
            });
          }
          );
          
        }, 200);
      });

    this.$validator.extend("financiamientounico", {
      validate: FinanciamientoUnico,
      getMessage: (field, params, data) => data.message,
    });
  },
  components: {
    historico,
    quillEditor
  },
  $_veeValidate: {
    validator: "new",
  },
  mounted() {
    this.$validator.localize("es", this.dictionary);
  },
  computed: {
    ...mapGetters([
      "gnacionalformulacion",
      "gnacional",
      "gpuntos",
      "gpilares",
      "gfuentes",
      "gcampos",
      "gexistefinanciamiento"
    ]),
    ...mapGetters("mensaje", [
      "ginformation",
      "gnodata",
      "glogo",
      "glogodnp",
      "gnosearch",
    ]),
    puedesalvar() {
      return !this.salvando && this.permisosalvar === true;
    },
    actividades() {
      return this.formulacion.actividad.filter(
        (p) => p.idestrategianacional === this.estrategia.idestrategianacional
      );
    },
    itemsporpagina2() {
      if (!isNaN(this.itemsPerPageSopCuan2)) return this.itemsPerPageSopCuan2;
      else return 1;
    },
    itemsporpagina3() {
      if (!isNaN(this.itemsPerPageSopCuan3)) return this.itemsPerPageSopCuan3;
      else return 1;
    },
    itemsporpagina4() {
      if (!isNaN(this.itemsPerPageSopCuan4)) return this.itemsPerPageSopCuan4;
      else return 1;
    },
  },
  methods: {
    ...mapActions([
      "get_nacionalformulacion",
      "put_nacionalformulacion",
      "get_nacional",
      "get_puntos",
      "get_camposestado",
      "get_pilares",
      "get_fuentes",
      "get_existefinanciamiento"
    ]),
    onEditorReady(quill) {
      quill.format("align", "justify");
    },
    onEditorChange({ quill }) {
        quill.getModule('counter').update();
    },
    apropiacionentera(item) {
      return  parseInt(item.apropiacion);
    },
    getusuario() {
      return JSON.parse(unescape(localStorage.usuario));
    },
    moneda(value) {
      const options2 = { style: "currency", currency: "COP" };
      const numberFormat2 = new Intl.NumberFormat("es-CO", options2);
      let cadena = numberFormat2.format(value.toFixed(0));
      return cadena.substring(0, cadena.length - 3);
    },
    formato(value) {
      if (value) {
        return moment(String(value.fechacumplimiento)).format("DD/MM/YYYY");
      }
    },
    formatofecha(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    invocarsalvado() {
      this.salvando = true;
      this.put_nacionalformulacion({ data: this.formulacion });
    },
    saveformulacion() {
      this.$validator.validateAll().then((result) => {
        if (this.$refs.actividad != undefined)
        {
          if (!result || this.$refs.actividad.quill.root.innerHTML ==='<p class="ql-align-justify"><br></p>') {
            this.snack = true;
            this.snackalert = false;
            this.buttontext = "Cerrar";
            this.timeoutsnak = 4000;
            let Errores = "";

            let bag = new ErrorBag();
            bag = this.errors;
            if(bag.first('Actividad', 'form-actividad') !== undefined)
              bag.removeById(bag.first('Actividad', 'form-actividad').id);

            if( this.$refs.actividad.quill.root.innerHTML ==='<p class="ql-align-justify"><br></p>' && bag.first('Actividad', 'form-actividad') == undefined)
            {
              bag.add({
                  scope: 'form-actividad',
                  field: 'Actividad',
                  msg: 'Los objetivos especificos son requeridos'
              });
            }

            this.$validator.errors.items.forEach((element) => {
              Errores = Errores + element.msg + "; ";
            });
            this.MesaggeInfo.mensajeRespuesta =
              "La validación del formulario contiene errores: " + Errores;
            this.MesaggeInfo.color = "infovue";
            return;
          } else {
            this.formulacion.finalizar = false;
            this.invocarsalvado();
          }
        } else
        {
          this.formulacion.finalizar = false;
          this.invocarsalvado();
        }
      });
    },
    finalizarformulacion() {
      this.ValidarRevisionComentario();
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "Cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";
          this.$validator.errors.items.forEach((element) => {
            Errores = Errores + element.msg + "; ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "La validación del formulario contiene errores: " + Errores;
          this.MesaggeInfo.color = "infovue";
          return;
        } else {
          let aprobar = this.showaprobacion("aprobado");
          if (
            aprobar &&
            (this.formulacion.comentarioflujo === null ||
              this.formulacion.aprobado === null)
          ) {
            this.snack = true;
            this.snackalert = false;
            this.timeoutsnak = 4000;
            this.MesaggeInfo.mensajeRespuesta =
              "Es obligatorio diligenciar los datos de revisión de la formulación";
            this.MesaggeInfo.color = "infovue";
            return;
          }
          this.formulacion.finalizar = true;
          let sfiltrogeneral = localStorage.filtrogeneral;
          let filtrogeneral = [];
          if (sfiltrogeneral !== undefined) {
            filtrogeneral = JSON.parse(unescape(sfiltrogeneral));
          }
          let proceso = filtrogeneral.filter((p) => p.idproceso === 6)[0];
          if (proceso === undefined) {
            proceso = { idproceso: 6, arreglo: [] };
            filtrogeneral.push(proceso);
          }
          let arreglo = proceso.arreglo;
          arreglo.push({
            idelemento: this.formulacion.idnacionalformulacion,
            fecha: new Date(),
          });
          localStorage.setItem("filtrogeneral", JSON.stringify(filtrogeneral));
          this.invocarsalvado();
        }
      });
    },
    ValidarRevisionComentario(){
      let bag = new ErrorBag();
        bag = this.errors;
        if(bag.first('revisioncomentario') !== undefined)
          bag.removeById(bag.first('revisioncomentario').id);

        if( this.$refs.revisioncomentario.quill.root.innerHTML.length > this.$refs.revisioncomentario.quill.options.modules.counter.max  && bag.first('revisioncomentario') == undefined)
        {
          bag.add({
              field: 'revisioncomentario',
              msg: 'está superando el límite de caracteres'
          });
        }
    },
    preventguardaractividad() {
      this.$validator.validateAll("form-actividad").then((result) => {
        if (!result) {
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "Cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";
          this.$validator.errors.items.forEach((element) => {
            Errores = Errores + element.msg + "; ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "La validación del formulario contiene errores: " + Errores;
          this.MesaggeInfo.color = "infovue";
          return;
        } else {
          this.actividad.fechacumplimiento = this.fecha;
          if (this.nuevaactividad === true) {
            this.salvarnuevactividad();
          } else {
            this.salvarexistenteactividad();
          }
        }
      });
    },
    preventguardarpresupuesto() {
      this.$validator.validateAll("form-presupuesto").then((result) => {
        if (!result) {
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";
          this.$validator.errors.items.forEach((element) => {
            Errores = Errores + element.msg + "; ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "La validación del formulario contiene errores: " + Errores;
          this.MesaggeInfo.color = "infovue";
          return;
        } else {
          this.presupuesto.idpunto = this.punto.idpunto;
          this.presupuesto.nombrepunto = this.punto.nombrecompleto;
          this.presupuesto.idpilar = this.pilar.idpilar;
          this.presupuesto.nombrepilar = this.pilar.nombrecompleto;
          this.presupuesto.idfuente = this.fuente.idfuente;
          this.presupuesto.nombrefuente = this.fuente.nombre;
          this.presupuesto.apropiacion = parseFloat(
            this.presupuesto.apropiacion
          );
          if (this.nuevopresupuesto === true) {
            this.salvarnuevopresupuesto();
          } else {
            this.salvarexistentepresupuesto();
          }
        }
      });
    },
    salvarnuevopresupuesto() {
      this.formulacion.financiamiento.push(this.presupuesto);
      this.editpresupuesto = false;
    },
    salvarexistentepresupuesto() {
      this.formulacion.financiamiento[
        this.indexpresupuesto
      ].idpilar = this.pilar.idpilar;
      this.formulacion.financiamiento[
        this.indexpresupuesto
      ].nombrepilar = this.pilar.nombrecompleto;
      this.formulacion.financiamiento[
        this.indexpresupuesto
      ].idfuente = this.fuente.idfuente;
      this.formulacion.financiamiento[
        this.indexpresupuesto
      ].nombrefuente = this.fuente.nombre;
      this.formulacion.financiamiento[
        this.indexpresupuesto
      ].nombrepunto = this.punto.nombrecompleto;
      this.formulacion.financiamiento[
        this.indexpresupuesto
      ].apropiacion = this.presupuesto.apropiacion;
      this.editpresupuesto = false;
    },
    salvarexistenteactividad() {
      let anterior = this.formulacion.actividad[this.indexactividad]
        .ponderacion;
      this.formulacion.actividad[
        this.indexactividad
      ].ponderacion = this.actividad.ponderacion;
      this.formulacion.actividad[
        this.indexactividad
      ].nombre = this.actividad.nombre;
      this.formulacion.actividad[
        this.indexactividad
      ].fechacumplimiento = this.actividad.fechacumplimiento;
      this.estrategias[this.indexestrategia].ponderado =
        parseInt(this.estrategias[this.indexestrategia].ponderado) +
        parseInt(this.actividad.ponderacion) -
        anterior;
      this.editactividad = false;
    },
    salvarnuevactividad() {
      this.formulacion.actividad.push(this.actividad);
      this.editactividad = false;
      this.estrategias[this.indexestrategia].ponderado =
        parseInt(this.estrategias[this.indexestrategia].ponderado) +
        parseInt(this.actividad.ponderacion);
      this.estrategias[this.indexestrategia].actividades =
        this.estrategias[this.indexestrategia].actividades + 1;
    },
    deleteactividad(item) {
      this.indexactividad = this.formulacion.actividad.indexOf(item);
      this.actividad = item;
      if (item.idactividad === 0) {
        this.deleteexistente();
      } else {
        this.dialog = true;
      }
    },
    deletepresupuesto(item) {
      this.indexpresupuesto = this.formulacion.financiamiento.indexOf(item);
      this.pilar = this.gpilares.filter((p) => p.idpilar === item.idpilar)[0];
      this.punto = this.gpuntos.filter(
        (p) => p.idpunto === this.pilar.idpunto
      )[0];
      this.fuente = this.gfuentes.filter(
        (p) => p.idfuente === item.idfuente
      )[0];
      this.presupuesto = item;
      if (item.idfinanciamiento === 0) {
        this.deletepresupuestoexistente();
      } else {
        this.dialogpresupuesto = true;
      }
    },
    deleteexistente() {
      this.estrategias[this.indexestrategia].ponderado =
        parseInt(this.estrategias[this.indexestrategia].ponderado) -
        parseInt(this.actividad.ponderacion);
      this.estrategias[this.indexestrategia].actividades =
        this.estrategias[this.indexestrategia].actividades - 1;
      this.formulacion.actividad.splice(this.indexactividad, 1);
      this.dialog = false;
    },
    deletepresupuestoexistente() {
      this.dialogpresupuesto = false;
      this.formulacion.financiamiento.splice(this.indexpresupuesto, 1);
    },
    newpresupuesto() {
      this.presupuesto = {
        idfinanciamiento: 0,
        idfuente: 0,
        nombrefuente: "",
        nombrepilar: "",
        nombrepunto: "",
      };
      this.editpresupuesto = true;
      this.nuevopresupuesto = true;
      this.punto = null;
      this.fuente = null;
      this.pilar = null;
    },
    newactividad() {
      console.log('this.estrategia.idestrategianacional',this.estrategia.idestrategianacional)
      this.actividad = {
        ponderacion: 0.0,
        idactividad: 0,
        idestrategianacional: this.estrategia.idestrategianacional,
        fechacumplimiento: new Date(),
      };
      this.fecha = null;
      this.editactividad = true;
      this.nuevaactividad = true;
    },
    grideditpresupuesto(item) {
      this.presupuesto = {
        apropiacion: item.apropiacion,
        idpilar: item.idpilar,
        idfuente: item.idfuente,
        idfinanciamiento: item.idfinanciamiento,
      };
      this.indexpresupuesto = this.formulacion.financiamiento.indexOf(item);
      this.pilar = this.gpilares.filter((p) => p.idpilar === item.idpilar)[0];
      this.punto = this.gpuntos.filter(
        (p) => p.idpunto === this.pilar.idpunto
      )[0];
      this.fuente = this.gfuentes.filter(
        (p) => p.idfuente === item.idfuente
      )[0];
      this.editpresupuesto = true;
      this.nuevopresupuesto = false;
    },
    grideditactividad(item) {
      this.actividad = {
        ponderacion: item.ponderacion,
        fechacumplimiento: item.fechacumplimiento,
        nombre: item.nombre,
        idestrategianacional: item.idestrategianacional,
      };
      this.indexactividad = this.formulacion.actividad.indexOf(item);
      this.fecha = this.actividad.fechacumplimiento;
      this.editactividad = true;
      this.nuevaactividad = false;
    },
    grideditestrategia(item) {
      this.estrategia = item;
      this.frameestrategia = true;
      this.indexestrategia = this.estrategias.indexOf(item);
    },
    coloractividad(valor) {
      if (valor === 0) return "red";
      else return "green";
    },
    colorponderado(valor) {
      if (valor !== 100) return "red";
      else return "green";
    },
    showaprobacion(control) {
      let mostrar = this.showcontrol(control);
      if (mostrar === true) {
        mostrar = this.permisosalvar;
      }
      return mostrar;
    },
    showcontrol(control) {
      if (this.estadocampos.length > 0) {
        let responsefound = this.estadocampos.filter(
          (p) => p.nombre == control
        );
        if (responsefound.length === 0) {
          return false;
        } else {
          return responsefound[0].visible;
        }
      }
    },
    readcontrol(control) {
      if (this.estadocampos.length > 0) {
        let responseread = this.estadocampos.find(function (element) {
          if (element.nombre == control) {
            return element;
          }
        });
        if (responseread == null) return true;
        else return responseread.lectura;
      }
    },
    functionalert() {
      if (this.buttontext == "Cerrar") {
        this.snack = false;
      }
      if (this.buttontext == "Aceptar") {
        this.buttontext == "Cerrar";
        this.snack = false;
        this.timeoutsnak = 4000;
        this.$router.push("/tareas");
      }
    },
    existepresupuestosinguardar() {
      let filtro = {
        idpilar: this.pilar.idpilar !== null ? this.pilar.idpilar: 0,
        idfuente: this.fuente !== null ? this.fuente.idfuente: 0,
        idpunto:  this.punto.idpunto !== null ? this.punto.idpunto: 0
      }
      let existepresupuestolocal = this.formulacion.financiamiento.filter(function(p){
         return p.idpilar ===  filtro.idpilar && 
              p.idfuente ===  filtro.idfuente &&
              p.idpunto === filtro.idpunto;
    }, filtro).length > 0;
      return existepresupuestolocal;
    },
  },
  watch: {
    gcampos() {
      this.estadocampos = this.gcampos;
      this.puedeeditarestrategia = !this.estadocampos.filter(
        (p) => p.nombre === "editaestrategia"
      )[0].lectura;

      if (this.puedeeditarestrategia === false) {
        let accion = this.headeractividad.filter(
          (p) => p.value === "action"
        )[0];
        let indexaccion = this.headeractividad.indexOf(accion);
        this.headeractividad.splice(indexaccion, 1);
      }
      this.puedeeditarfinanciamiento = !this.estadocampos.filter(
        (p) => p.nombre === "editafinanciamiento"
      )[0].lectura;
      if (this.puedeeditarfinanciamiento === false) {
        let accion = this.headerpresupuesto.filter(
          (p) => p.value === "action"
        )[0];
        let indexaccion = this.headerpresupuesto.indexOf(accion);
        this.headerpresupuesto.splice(indexaccion, 1);
      }
    },
    punto: function () {
      if (this.punto !== null) {
        this.pilares = this.gpilares.filter(
          (p) => p.idpunto === this.punto.idpunto
        );
      }
    },
    gnacionalformulacion: function () {
      this.formulacion = this.gnacionalformulacion;
      let nombre = this.formulacion.idperiodoNavigation.nombre;
      this.validacionfecha =
        "required|date_format:dd/MM/yyyy|date_between:01/01/" +
        nombre + ",31/12/" + nombre + ", ()";

      let usuario = this.getusuario();
      this.permisosalvar = false;
      if (this.formulacion.idusuarioresponsable != undefined) {
        this.permisosalvar =
          usuario.idusuario === this.formulacion.idusuarioresponsable
            ? true
            : false;
      } else {
        let rolexiste = usuario.usuarioRol.filter(
          (p) => p.idrol === this.formulacion.idrolresponsable
        )[0];
        if (rolexiste !== undefined) {
          this.permisosalvar = true;
        }
      }
      this.get_nacional({
        params: {
          idnacional: this.formulacion.idnacionalNavigation.idnacional,
        },
      });
      this.get_camposestado({
        params: {
          idtabla: "nacionalformulacion",
          idestado: this.formulacion.idestado,
        },
      });
    },
    gnacional() {
      this.nacional = this.gnacional;
      this.estrategias = this.nacional.estrategiaNacional.filter(
        (p) => p.activo === true
      );
      for (let index = 0; index < this.formulacion.actividad.length; index++) {
        let indexe = this.estrategias.indexOf(
          this.estrategias.filter(
            (p) =>
              p.idestrategianacional ===
              this.formulacion.actividad[index].idestrategianacional
          )[0]
        );
        this.estrategias[indexe].actividades =
          this.estrategias[indexe].actividades + 1;
        this.estrategias[indexe].ponderado =
          this.estrategias[indexe].ponderado +
          this.formulacion.actividad[index].ponderacion;
      }
    },
    ginformation() {
      this.salvando = false;
      this.MesaggeInfo = this.ginformation;
      this.snack = true;
      if (this.MesaggeInfo.codigoRespuesta === "") {
        setTimeout(() => {
          let id = this.formulacion.idnacionalformulacion;
          this.get_nacionalformulacion({
            params: {
              idnacionalformulacion: id,
            },
          });
        }, 1000);
        if (this.formulacion.finalizar === true) {
          this.buttontext = "Aceptar";
          this.timeoutsnak = 0;
          this.snack = true;
          this.puedesalvar = false;
          this.MesaggeInfo.mensajeRespuesta =
            "El proceso de formulación ha finalizado; presione aceptar para continuar";
          this.MesaggeInfo.color = "infovue";
        }
      }
    },
    fecha() {
      let e = this.formatofecha(this.fecha);
      this.fechaformato = e;
    },
    gexistefinanciamiento(){
      this.existefinanciamiento = this.gexistefinanciamiento;
    }
  },
};
</script>